import { postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel, PaginationFilterRequest, PaginatedSelectModel } from "@/models/core.model";
import { EncyclopediaItem, EncyclopediaItemPaginationFilterRequest, UpsertEncyclopediaItem } from '@/models/encyclopedia-item.model';

export const getPagedEncyclopediaItems = async (input: EncyclopediaItemPaginationFilterRequest): Promise<PagedResponseModel<EncyclopediaItem>> => {
  return await getReq(createUrl("a/Encyclopedia/Item/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getEncyclopediaItemsLookup = async (input?: string, page?: number): Promise<PaginatedSelectModel> => {
  const model: PaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false
  };
  return await getPagedEncyclopediaItems(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: itm.name
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })         
  );
};

export const getEncyclopediaItem = async (id: number): Promise<BaseResponseModel<EncyclopediaItem>> => {
  return await getReq(createUrl(`a/Encyclopedia/Item/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertEncyclopediaItem = async (input: UpsertEncyclopediaItem): Promise<BaseResponseModel<EncyclopediaItem>> => {
  return await postReq(createUrl("a/Encyclopedia/Item/Upsert"),
    input
  ).then((res: any) => res.data);
};
